import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Custom by <b><a href="#" target="_blank">Transcode</a></b> 2021</span>
  `,
})
export class FooterComponent {
}
